import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SecurityDefinitionsList from './SecurityDefinitionsList';
import SecurityDefinitionForm from './SecurityDefinitionForm';
import SecurityDefinitionDetail from './SecurityDefinitionDetail';

import { AuthStdFooter } from "../../utils/auth-std-footer";
/**
 * SecurityRegistryManager component that serves as the container for all security registry management UI
 * This component handles routing between different security registry management views
 * Mirrors the PathRegistryManager structure for consistency
 * @returns {JSX.Element} SecurityRegistryManager component
 */
const SecurityRegistryManager = () => {
  return (
    <Routes>
      {/* List view - default route */}
      <Route index element={<SecurityDefinitionsList />} />

      {/* Create new security definition */}
      <Route path="create" element={<SecurityDefinitionForm />} />

      {/* View security definition details */}
      <Route path=":name/view" element={<SecurityDefinitionDetail />} />

      {/* Edit security definition */}
      <Route path=":name/edit" element={<SecurityDefinitionForm />} />

      {/* Redirect any other paths to the list view */}
      <Route path="*" element={<Navigate to="/admin/security-registry" replace />} />
    </Routes>
  );
};

export default SecurityRegistryManager;
